/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    mode: "live",
    modeOptions: [
        { label: 'Live', value: 'live' },
        { label: 'Dev', value: 'dev', disabled: true },
        { label: 'Flush Cache', value: 'flushcache', disabled: true },
    ]
};
const main = createSlice({
    name: "main",
    initialState: { ...initialState },
    reducers: {
        setDisplayMode: (state, action) => {
            state.mode = action.payload;
        },
        setModeOptionStatus: (state, action) => {
            const { key, disabled } = action.payload
            state.modeOptions = state.modeOptions.map((opt) => {
                if (key === opt.value) return {
                    ...opt,
                    disabled
                }
                return opt
            });
        }
    }
});

const { reducer, actions } = main;
export const {
    setDisplayMode,
    setModeOptionStatus
} = actions;
export default reducer;
